import type { JSX } from 'react';
import { Orb } from '../shell/orb';

/**
 * Four questions a dispatcher actually asks, to show what the agent is for.
 * Asking one sends it as if typed.
 */
const SUGGESTIONS = [
  { tag: 'LIVE', text: 'Where is truck 214 right now?' },
  { tag: 'LOAD', text: 'What is the status of load 4471?' },
  { tag: 'HOS', text: 'How many driving hours does Dmitri have left today?' },
  { tag: 'EMAIL', text: 'What did the broker say about the detention on load 4460?' },
] as const;

export function EmptyThread({
  onAsk,
  disabled,
}: {
  onAsk: (text: string) => void;
  disabled: boolean;
}): JSX.Element {
  return (
    <div className="m-auto flex max-w-[560px] flex-col items-center gap-[18px] py-5 text-center">
      <Orb size={64} />
      <div>
        <div className="text-[22px] font-semibold tracking-[-.02em]">What do you need to know?</div>
        <div className="text-mute mt-1.5 text-sm leading-normal">
          I answer from your TMS, emails, Telegram groups, Samsara and GoMotive. Ask about loads,
          trucks, drivers or brokers.
        </div>
      </div>
      <div className="grid w-full grid-cols-1 gap-2 tab:grid-cols-2">
        {SUGGESTIONS.map((s) => (
          <button
            key={s.tag}
            type="button"
            disabled={disabled}
            onClick={() => onAsk(s.text)}
            className="border-line bg-bg hover:border-acc rounded-xl border px-3.5 py-3 text-left text-[13px] leading-[1.4] text-inherit transition-[border-color,transform] duration-200 hover:-translate-y-px disabled:opacity-60"
          >
            <span className="text-acc mb-1 block font-mono text-[10px] tracking-[.08em]">
              {s.tag}
            </span>
            {s.text}
          </button>
        ))}
      </div>
    </div>
  );
}
